<template>
    <div class="oin-pay">
        <navigation-bar Close/>
        <!--todo 這個是修改密碼/刪除錢包的連結 -->
        <div class="fixed-more" @click="goPayEdit()" v-if="isHaveToken">
            <i class="el-icon-more"/>
        </div>

        <div class="main qr-code">
            <!--todo 這個是未綁卡 -->
            <div v-if="!isHaveToken" class="fadeIn">
                <div class="no-data">
                    <img src="../../assets/images/empty.svg">
                    <p>目前尚無綁定信用卡</p>
                </div>
                <div class="footer-button mt-0 mb-5">
                    <el-button type="primary" class="w-50" round @click="addPayToken(true)">立即綁定信用卡</el-button>
                </div>
            </div>
            <div v-else class="Bound">
                <div class="flex-grow-1">
                    <div class="qr-block">
                        <div class="card-number">
                            <span><img src="../../assets/images/pay/other_pay_credit_card3.svg">{{selectItem.name}}</span>
                            <span>*{{selectItem.card4No}}</span>
                        </div>
                        <div id="qrcode"/>
                        <div class="ps small">享樂遊錢包可用於點餐支付</div>
                    </div>
                    <!--TODO 等實際開發掃描時用-->
                    <div class="renew small" v-if="false">
                        <el-button icon="el-icon-refresh-right"
                                   size="mini"
                                   class="mr-1"
                                   circle/>
                        更新 04:27
                    </div>
                </div>


                <!--TODO 綁定信用卡詳細-->
                <CreditCard :list="dataList" :key="creditCardKey" @triggerEvent="creditCardEvent"/>
            </div>
        </div>

        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    import CreditCard from '../pay/components/CreditCard';
    import auth from "@/util/auth";
    export default {
        name: "OINPay",
        components: {
            CreditCard
        },
        data() {
            return {
                isLoading:false,
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",
                dataObject: {},
                isHaveToken: false,
                isHavePayPassword: false,
                //綁定信用卡詳細
                showCreditCard: false,
                dataList: [],
                selectItem: {},
                isGoPayPassword: false,//只有綁定完導支付密碼才轉過去，反之可能是回上一頁的操作，就回個人中心
                successRouterName: "OINPay",
                fromRoute: {},
                creditCardKey: 0,
            }
        },
        created() {
            let isOk = false

            try {
                this.$crypto.decryptText(this.$auth.getAdminToken())
            } catch (e) {
                this.$router.go(-1);
                return false;
            }

            if (this.dataToken !== "") {
                try {
                    let dataObject = this.$crypto.uriComponentToObject(this.dataToken)
                    if (dataObject.usedType === this.$route.name) {
                        this.dataObject = dataObject
                        this.successRouterName = this.dataObject.successRouterName || "OINPay"

                        isOk = true
                    } else {
                        this.$public.showNotify("參數異常", false);
                        this.$router.push({name: 'More'})
                    }
                } catch (e) {
                    this.$public.showNotify("參數異常", false);
                    this.$router.push({name: 'More'})
                }
            } else {
                isOk = true
            }

            if (isOk) {
                this.setupData();
            }
        },
        beforeRouteEnter: function(to, from, next) {
            next(
                vm => {
                    vm.fromRoute = from;
                }
            );
        },
        beforeRouteLeave: function (to, from, next) {
            if (to.name === "PayPassword" && !this.isGoPayPassword) {
                this.$router.push({name: 'More'})
            } else {
                next()
            }
        },
        methods: {
            setupData() {
                //如果是開著就先關閉，撈完再打開
                let showCreditCard = this.showCreditCard;
                if(showCreditCard) {
                    this.showCreditCard = false;
                }

                this.$http.fetchWithAuthEncrypt`GetUserPayTokenList${{}}
                ${json => {
                    if (json.status) {
                        let data = json.data;
                        this.isHaveToken = data.isHaveToken;
                        this.isHavePayPassword = data.isHavePayPassword;
                        if(this.isHaveToken && (!this.isHavePayPassword || this.fromRoute.name === null)) {
                            this.$router.go(-1);
                        } else {
                            this.dataList = data.dataList;
                            this.dataList.forEach(item => {
                                if(item.isDefault) {
                                    this.selectItem = item
                                }
                            })

                            if(showCreditCard) {
                                this.showCreditCard = true;
                            }
                            this.creditCardKey++;
                        }
                    } else {
                        this.$public.showNotify(json.message, json.status);
                    }
                }}`;
            },
            creditCardEvent(obj) {
                let self = this;
                let event = obj.event;
                if (event === "updateDefault") {
                    if(this.selectItem.id !== obj.selectItem.id) {
                        this.updateDefault(obj.selectItem.id)
                    } else {
                        self.showCreditCard = false;
                    }
                } else if (event === "cancel") {
                    self.showCreditCard = false;
                } else if (event === "addPayToken") {
                    this.addPayToken(false);
                } else if (event === "deletePayToken") {
                    this.deletePayToken(obj.selectItem.id);
                } else if (event === "updatePayTokenName") {
                    this.updatePayTokenName(obj.selectItem.id, obj.content);
                }
            },
            async addPayToken(isEmpty) {
                let self = this

                await self.$payment.bindCreditCard(function (payResult) {
                    if(isEmpty) {
                        let isHaveToken = payResult.data.isHaveToken
                        let isHavePayPassword = payResult.data.isHavePayPassword

                        if (isHaveToken && !isHavePayPassword) {
                            self.goPayPassword(isHavePayPassword)
                        } else {
                            self.setupData();
                        }
                    }  else {
                        self.setupData();
                    }

                }, function (payResult) {
                    self.$public.showNotify(payResult.message, payResult.status);
                })
            },
            updateDefault(id) {
                this.$http.fetchWithAuthEncrypt`UpdateDefaultOinPay${{
                    userToken: auth.getAdminToken(),
                    userPayTokenId: id,
                }}
                ${json => {
                    this.showCreditCard = false;
                    if (json.status) {
                        this.setupData();
                    }
                    this.$public.showNotify(json.message, json.status);
                }}`;
            },
            deletePayToken(id) {
                this.$http.fetchWithAuthEncrypt`DeletePayToken${{
                    userToken: auth.getAdminToken(),
                    userPayTokenId: id,
                }}
                ${json => {
                    if (json.status) {
                        this.setupData();
                    }
                    this.$public.showNotify(json.message, json.status);
                }}`;
            },
            goPayPassword(isHavePayPassword) {
                let self = this;
                let routerName = "PayPassword"
                let dataToken = self.$crypto.objectToURIComponent({
                    usedType: routerName,
                    isHavePayPassword: isHavePayPassword,
                    successRouterName: self.successRouterName,
                })

                self.isGoPayPassword = true;
                self.$router.push({name: routerName, query: {'dataToken': dataToken}})
            },
            goPayEdit() {
                let self = this
                let routerName = "PayEdit"
                let dataToken = self.$crypto.objectToURIComponent({
                    usedType: routerName,
                    isHavePayPassword: self.isHavePayPassword,
                    successRouterName: self.successRouterName,
                })

                self.$router.push({name: routerName, query: {'dataToken': dataToken}})
            },
            updatePayTokenName(id, name) {
                this.$http.fetchWithAuthEncrypt`UpdatePayTokenName${{
                    userToken: auth.getAdminToken(),
                    userPayTokenId: id,
                    userPayTokenName: name,
                }}
                ${json => {
                    if (json.status) {
                        this.setupData();
                    }
                    this.$public.showNotify(json.message, json.status);
                }}`;
            },
        }

    }
</script>

<style lang="less" scoped src="../../less/oinPay.less"/>
